const USERS_URLS = { 
  GET_ALL: "/user/get_all",
  UPDATE: "/user/update",
  GET_ONE: "/user/get_one",
  DELETE: "/user/delete_one",
  GET_ALL_SELECT: "/user/get_all_select",

  PASS_RESET: "/auth/password_reset",
  UPDATE_STATUS: "auth/update_status"
};


export {
  USERS_URLS
};

